import { slick } from "@accessible360/accessible-slick";

class FeaturedEvents {
    constructor(element) {
        this.el = element;
        this.init();
    }

    init() {
        this.createCarousel();
    }

    createCarousel() {
        const arrow = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 32"><path d="M.9 31A3 3 0 0 0 5 31l12.7-12.7a3 3 0 1 0-4.2-4.3L1 26.7a3 3 0 0 0 0 4.3Z"/><path d="M.9 1a3 3 0 0 0 0 4.3L13.6 18a3 3 0 1 0 4.2-4.3L5.1 1A3 3 0 0 0 1 1Z"/></svg>`;

        const props = {
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 2,
            slidesToScroll: 1,
            adaptiveHeight: false,
            arrows: true,
            arrowsPlacement: "beforeSlides",
            prevArrow:
                '<button type="button" data-control-prev><span class="sr-text">Previous</span>' +
                arrow +
                "</button>",
            nextArrow:
                '<button type="button" data-control-next><span class="sr-text">Next</span>' +
                arrow +
                "</button>",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        infinite: true,
                    },
                },
            ],
        };

        let carousel = $(this.el).slick(props);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const carousels = document.querySelectorAll(
        "[data-carousel='featured-events']",
    );
    carousels.forEach((element) => {
        new FeaturedEvents(element);
    });
});
